import React from 'react';
import { Tag } from 'antd';
import styled from 'styled-components';
import {
  statusFontColorMap,
  statusBGColorMap,
  statusTextMap,
} from './statusConfig';

export type PublishStatusType = 'NEW' | 'PUBLISHED' | 'OFFLINE';

const AlbumStatusTag = styled(Tag)`
  position: absolute;
  top: 0;
  right: 0;
  width: 63px;
  height: 18px;
  margin: 0;
  border-radius: 0 4px;
  text-align: center;
  line-height: 18px;
`;

function StatusTag(props: { status: PublishStatusType; style?: any }) {
  const { status } = props;
  return (
    <AlbumStatusTag
      style={{ color: statusFontColorMap[status], ...props.style }}
      color={statusBGColorMap[status]}>
      {statusTextMap[status]}
    </AlbumStatusTag>
  );
}

export default StatusTag;
